import React from 'react';
import { Section } from './Section';
export function GuaranteeSection() {
  return <Section className="bg-bgLight py-20 px-4 sm:px-6 lg:px-8" data-id="element-103">
      <div className="max-w-3xl mx-auto" data-id="element-104">
        <div className="bg-gradient-to-br from-[#F5EFF8] to-[#EDE4F5] rounded-3xl p-8 md:p-12 text-center border-2 border-ctaFrom shadow-[0_0_40px_rgba(192,132,252,0.1)] relative overflow-hidden" data-id="element-105">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-ctaFrom via-moonGlow to-ctaFrom opacity-50" data-id="element-106"></div>

          <div className="text-5xl mb-6 text-ctaTo" data-id="element-107">🛡️</div>
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-headlineDark mb-8" data-id="element-108">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <div className="space-y-4 text-lg text-bodyOnLight mb-8" data-id="element-109">
            <p data-id="element-110">Abrís los módulos. Los aplicás.</p>
            <p data-id="element-111">Si en 7 días no es lo que esperabas:</p>
            <p className="text-2xl font-bold text-headlineDark my-6" data-id="element-112">
              devolución del 100%
            </p>
            <p data-id="element-113">sin formularios, sin drama.</p>
          </div>

          <div className="inline-block bg-white px-6 py-3 rounded-full text-sm font-medium text-bodyOnLight border border-cardBorder" data-id="element-114">
            Tasa de devoluciones: menos del 1%.
          </div>
        </div>
      </div>
    </Section>;
}